import React from 'react';
import {List, Datagrid, TextField} from 'react-admin';
import ButtonCreateClient from './ButtonCreateClient';

const PostBulkActionButtons = () => (<ButtonCreateClient/>);

export const ClientList = props => {
  return (
    <>
      <List
        title='Hydrant Fleet Management - Clients' 
        exporter={false} 
        perPage={50}
        bulkActionButtons={<PostBulkActionButtons />}
      >
        <Datagrid>
          <TextField label="Client Id" source="id" />
          <TextField label="Name"source="name" />
        </Datagrid>
      </List>
    </>  
  );
};

  
  